export default (alignment: string) => {
    switch(alignment) {
        case "Center":
            return "center";
        case "Right":
            return "right";
        case "Justify":
        case "Justified":
            return "justify";
        default:
            return "left";
    }
};